module.exports = __webpack_public_path__ + "img/model.50e05f38.svg";